<script>
  import { _ } from 'svelte-i18n'
  import CardMainContent from '/components/Widgets/CardMainContent'
  import Related from '/components/Groups/Related'
  import Body from '/Groups/Body'
  import Image from '/Atoms/Image'

  export let data

  let artist = data?.artist || {}

  let image = artist?.image?.[0]
  let body = artist.body || []

  // .join("\n")

</script>

<div class="container">

  <section class="main">
    <CardMainContent
      category={$_("menu.artists")}
      category_link="/artists"
      title={ artist.title }
    >
    {#if image}
      <div class="image">
        <Image 
          src={image.url}
          srcset={`${image.url} 1x, ${image.url2x} 2x`}
          caption = {image.imageCaption}
          credits = {image.credits}
          alt = {image.title}
          />
      </div>
    {/if}
    <Body {body} />
    </CardMainContent>

    <Related data={artist} />

  </section>

  <aside class="side">
    <!--SideGroup /-->
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  .image {
    padding-bottom: 1em;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  li, a {
    @include typo-grotesk-text-24;
  }

</style>